






















/* Created- 16 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { OwnerPaymentDTO, CustomerArticleLicenceDTO } from "../../Generated/ParticaAPI";
import { ParticaEvent, eParticaAction } from "../../Models/ParticaEvent";
@Component(
	{
		name: "ArticleLicences"
	})
export default class ArticleLicences extends Vue {
	@Prop() private data: CustomerArticleLicenceDTO[];
	private search: string = "";
	private headers: any = [
		{ text: "Name", value: "name" },
		{ text: "Description", value: "description" },
		{ text: "Modified", value: "timestamp" },
		{ text: "Default", value: "default" },
	];

	private select(item: CustomerArticleLicenceDTO) {
		this.$emit("partica-event", { action: eParticaAction.SELECT_ARTICLE_LICENCE, item } as ParticaEvent);
	}
}
